import { Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { AuthService } from 'src/app/auth/auth.service';
import { VoucherIssuance } from 'src/app/models/voucher';
import { emptyFields, purchaseTypeOptions, ReportTerminals, UsersType, UserTypes, voucherTypeOptions } from 'src/app/utilities/common-file';
import { CommonService } from 'src/app/utilities/common-service';
import { Messages } from 'src/app/utilities/message';
import { NzNotificationService } from 'src/app/utilities/ng-zorro-antd.module';
import { NzTableData } from 'src/app/utilities/nz-table.adapter';
import { DownloadService } from '../../reports/download-service';
import { VouchersService } from '../vouchers.service';

@Component({
  selector: 'app-redeemed-voucher',
  templateUrl: './redeemed-voucher.component.html'
})
export class RedeemedVoucherComponent implements OnInit {
  private tableData: NzTableData<VoucherIssuance, any> = new NzTableData<VoucherIssuance, any>(new VoucherIssuance(), 'fullName',);
  loading = false;
  merchantId: any;
  locationId: any;
  currencySymbol = '';
  selectedProduct: any;
  notifyLogout: any;
  selectedMerchantProduct: any;
  emptyField = emptyFields;
  userRole = UserTypes;
  role: string;
  vouchersTypeOptions = voucherTypeOptions;
  purchaseTypeOptions = purchaseTypeOptions;
  userType = UsersType;
  locationsList = [];
  loginUserType = '';
  voucherCodeModal: NzModalRef;
  voucherCode: any;
  validateLoading: boolean;
  locationListShow: boolean;
  errorMessage: any;
  showDownload: string;
  downloadList = [];
  showAppCodeFilter=false;



  // tslint:disable-next-line: max-line-length
  constructor(
    private voucherService: VouchersService,
    private authService: AuthService,
    private commonService: CommonService,
    private downloadService: DownloadService,
    private notification: NzNotificationService
  ) { }

  ngOnInit() {
    this.loginUserType = this.authService.getRole();
    this.tableData.search.merchant = this.authService.getMerchantId();
    if (this.loginUserType === this.userRole.merchant) {
      this.locationListShow = true;
      this.locationsList = this.authService.getLocationDetails();
    } else {
      this.locationListShow = false;
      // this.tableData.search.locationId = '';
      this.locationId = this.authService.getLocationId();
      this.tableData.search.location = this.authService.getLocationId();
    }
    this.refresh();
  }

  // For List
  refresh(startFromPageOne: boolean = true): void {
    this.loading = true;
    this.tableData.data = [];
    if (startFromPageOne) {
      this.tableData.pageIndex = 1;
    }
    const args = {
      pageIndex: this.tableData.pageIndex,
      pageSize: this.tableData.pageSize
    }
    this.voucherService.redeeemdVouchersList(this.tableData).subscribe((response: any) => {

      this.loading = false;
      this.tableData.total = response.data.total;
      if (response.data && response.data.voucherCodes) {
        this.tableData.data = response.data.voucherCodes;
        this.showDownload = Messages.downloadReport;
      } else {
        this.tableData.data = [];
        this.showDownload = '';
      }
    }, (err) => {
      this.loading = false;
      this.showDownload = '';
      this.tableData.data = [];
    });
  }

  //  For Page Index change
  onIndexChange(event) {
    this.tableData.pageIndex = event;
    this.refresh(false);
  }

  downloadReport() {
    // if (this.tableData.search.createdDate.startDate && this.tableData.search.createdDate.endDate) {
    this.notification.info('Download Processing', 'Please Wait', {
      nzKey: 'key'
    });
   
    const value = {
      voucherName: this.tableData.search.voucherName,
      code: this.tableData.search.code,
      redeemedLocation: this.tableData.search.location ,
      location: this.tableData.search.location ,
      redeemedMerchant: this.tableData.search.merchant ,
      status: 5,
      appCode: this.tableData.search.appCode,
      pageSize: 0,
      pageIndex: 1
    };
    var location ;
    if(value.location && this.locationListShow){
      location = this.locationsList[this.locationsList.findIndex(x => x.id === value.location)].name;
    }

    let gridFooter = [];
    let footerData = [];
   

    const filterHeaders = ['Voucher Code', 'Voucher Name', this.locationListShow ? 'Location' : ''];
   
    const filterData = [value.voucherName,
    value.code,
    this.locationListShow ? location : ''
    ];

    this.voucherService.redeeemdVouchersReport(value).subscribe((response: any) => {
      this.downloadList = response.data.voucherCodes;
      let headers = [];
      if (this.downloadList.length > 0) {
        if (this.locationListShow) {
          headers = ['Voucher Code', 'Voucher Name', 'Voucher Purchase Type',
            'Mobile Number', 'Display Name', 'Location', 'Price', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        } else {
          headers = ['Voucher Code', 'Voucher Name', 'Voucher Purchase Type',
            'Mobile Number', 'Display Name', 'Price', 'Created Date', 'Created By', 'Updated Date', 'Updated By'];
        }
        // tslint:disable-next-line: max-line-length
        if (this.locationListShow) {
          this.downloadService.onDownloadExcel(headers, ReportTerminals.redeemedVoucherReport, this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.redeemedVoucherReport, ReportTerminals.redeemedVoucherReport, filterHeaders, filterData, gridFooter, footerData);
        }
        else {
          this.downloadService.onDownloadExcel(headers, ReportTerminals.redeemedVoucherReport2, this.tableData.search.createdDate.startDate, this.tableData.search.createdDate.endDate, this.downloadList, ReportTerminals.redeemedVoucherReport2, ReportTerminals.redeemedVoucherReport2, filterHeaders, filterData, gridFooter, footerData);
        }
      }
    });
    // } else {
    //   this.notification.error(Messages.noDateSelected, '', {
    //     nzKey : 'key'
    //   });
    // }
  }

  // Clear search fields
  clearSearchVoucherCodeFields(value) {
    return this.voucherService.clearSearchVoucherCodeFields(this.tableData, value);
  }

  // close() {
  //   this.voucherCodeModal.close();
  // }

  // To Show User Type in grid
  getUserType(role) {
    return this.commonService.getUserType(role);
  }
  // To Show Voucher Type
  getVoucherType(type) {
    return this.commonService.getVoucherType(type);
  }
  // For User Voucher Type Tag color
  getVoucherTypeColor(type) {
    return this.commonService.getVoucherTypeColor(type);
  }
  // To Show getVoucher Purchase Type 
  getVoucherPurchaseType(type) {
    return this.commonService.getVoucherPurchaseType(type);
  }
  // Forget Voucher Purchase Type Tag color
  getVoucherPurchaseTypeColor(type) {
    return this.commonService.getVoucherPurchaseTypeColor(type);
  }
  // To show currency symbol for amount
  getCurrency(currency) {
    return this.commonService.getCurrency(currency);
  }

  // To Show voucher status
  getVoucherStatus(status) {
    return this.commonService.getVoucherStatus(status);
  }
  // For voucher Status Tag color
  getVoucherStatusColor(status) {
    return this.commonService.getVoucherStatusColor(status);
  }

}
